module.exports = __webpack_public_path__ + "static/media/contest2025_fourth_place_image.ec4601ea.jpeg";